import {ChangeDetectorRef,Component,OnInit,TemplateRef,ViewChild,EventEmitter,Output,} from "@angular/core";
import {NgbDate,NgbCalendar,NgbDateParserFormatter,} from "@ng-bootstrap/ng-bootstrap"; // for date range
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { BsModalService } from "ngx-bootstrap/modal";
import * as moment from "moment";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Sort } from "@angular/material/sort";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "../../../../environments/environment";
import * as XLSX from "xlsx";

@Component({
  selector: "app-projectlist",
  templateUrl: "./projectlist.component.html",
  styleUrls: ["./projectlist.component.css"],
})
export class ProjectlistComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("showimport") showimport: any;
  @Output() clearEvent = new EventEmitter<void>();
  displayedColumns: string[] = ["ProjectId","ProjectName","SalesEngineerUser","QuotationEngineerUser","TerritoryName","ProjectStatusName","UserName","CreatedDate","ACTION"];
  sortData: any = { column: "ProjectId", direction: "asc" };
  dtOptions: any = {};
  currentPage: any = 0;
  pageSize: any = 10;
  totalSize: number;
  dataSource: any;
  Source: any;
  id: any;
  deleteId: any;
  removeId: any;
  RestoreId: any;
  modalRef: any;
  err_message: any;
  file: any;
  restoreId: any;
  files: any;
  showcompany: any = [];
  permission: any;
  delstatus: any;
  userid: any;
  baseurl: any;

  // editableValue: string;
  // editingRowIndex: number = -1;
  // editingColumnKey: string = '';

  dropdownSettings: any = {};
  dropdownSetting0: any = {};
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  dropdownSetting5: any = {};
  quotationArray: any = [];
  salesArray: any = [];
  TerritoryArray: any = [];
  nameArray: any = [];
  downicon: boolean = true;
  upicon: boolean = true;
  columnsort: any;
  ProjectArray: any = [];
  StatusArray: any = [];
  date_range: any = { startDate: moment, endDate: moment };
  isValid: boolean = false;
  Totalrec: any = 0;
  invalid: any = 0;
  valid: any = 0;
  dataarray: any = [];
  count: any;
  arrHeader: any = [];
  showproject: any = [];
  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  invalidDates: moment.Moment[] = [
    moment().add(2, "days"),
    moment().add(3, "days"),
    moment().add(5, "days"),
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, "day"));
  };

  //changes for lazy load
  showMoreContactList: boolean = false;
  showMoreLoader: boolean = true;
  ItemPerPages: number;
  TotalRecord: any;
  userSearch: string;
  searchValueString: string;
  appUrl: string;
  sortArraySelect: string = "TotalProjects";
  sortingProperty: string = "";
  ascDesType: string = "Descending";
  SortType: string = "desc";
  totalCount: number;
  showTable: boolean;

  //Date range
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  selecteddate_range: any[];
  selectedselect_date: any[];

  //Date range
  hoveredDate2: NgbDate | null = null;
  fromDate2: NgbDate | null;
  toDate2: NgbDate | null;

  ProjectId: string = "";
  isExcelFile: boolean;
  inputFile: any;
  upfile: File;
  data: any[];
  type: string;
  namesort: string;
  quotation: any = [];
  nameId: any = [];
  sales: any = [];
  territory: any = [];
  status: any = [];
  pvalue: any;
  samplefile_project: string;
  userRId: any;

  //Date range in constructor
  constructor(
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private calendar2: NgbCalendar,
    public formatter2: NgbDateParserFormatter,
    private datePipe: DatePipe,
    private changeDetectorRefs: ChangeDetectorRef,
    private UserService: UserService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), "d", 10);
  }
  isCollapsed: boolean = false;
  isCollapsed1: boolean = false;
  start_date: string;
  end_date: string;
  timezone: any;

  registerForm = this.formBuilder.group({
    ProjectId: [""],
    QuotationEngineer: [""],
    SalesEngineer: [""],
    ProjectSource: [""],
    Territory: [""],
    ProjectStatus: [""],
    StartDate: [""],
    EndDate: [""],
    password: [
      "",
      [
        Validators.required,
        Validators.pattern(
          "(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{6,15}"
        ),
        Validators.minLength(6),
      ],
    ],
  });

  searchword: any = "";
  ngOnInit(): void {
    this.date_range.startDate = "";
    this.date_range.endDate = "";
    this.start_date = "";
    this.end_date = "";
    let userid = localStorage.getItem("userId");
    this.userid = this.UserService.decryptData(userid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    this.baseurl = environment.api_url;
    this.isCollapsed = false;
    this.samplefile_project = environment.import_sample;

    this.dropdownSetting0 = {
      singleSelection: false,
      text: "Quotation Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting1 = {
      singleSelection: false,
      text: "Sales Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting2 = {
      singleSelection: false,
      text: "Project Source",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting3 = {
      singleSelection: false,
      text: "Territory",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting4 = {
      singleSelection: false,
      text: "Project Status",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting5 = {
      singleSelection: false,
      text: "Project Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    let data = {
      ProjectId: "",
      QuotationEngineer: "",
      SalesEngineer: "",
      Territory: "",
      ProjectSource: "",
      ProjectStatus: "",
      SearchWord: this.searchword,
      Sort: "",
      SortWise: "",
      Export: "false",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.spinner.show();
    this.UserService.ProjectListFilter(data).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.spinner.hide();
          this.currentPage = 0;
          this.showcompany = response["ContactList"];
          this.dataSource = new MatTableDataSource<any>(
            response["ContactList"]
          );
          this.dataSource.paginator = this.paginator;
          this.TotalRecord = response["TotalRecord"];
          this.totalSize = response["TotalRecord"];
          this.iterator();
        } else if (response["result"] == "Failed") {
          this.toastr.error(response["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(response["Msg"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );

    this.Quotation();
    this.Sales();
    this.Territory();
    this.Status();
    this.GetAllProject();
  }

  get f() {
    return this.registerForm.controls;
  }

  Quotation() {
    let data = {};
    this.quotation = [];
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.quotationArray = res;
        this.quotation = [];
        for (const quotationData of this.quotationArray["Data"]) {
          this.quotation.push({
            id: quotationData["UserId"],
            itemName: `${quotationData["UserName"]} - ${quotationData["EmployeeId"]}`,
          });
        }
      } else {
        this.quotationArray = [];
      }
    });
  }
  selectedQuotation: any = [];
  selectedEngineer: string = "";
  selectedQuotationId: string = "";
  onQuotationSelect(item: any) {
    this.selectedEngineer = "";
    this.selectedQuotationId = "";
    this.selectedQuotation.forEach((element) => {
      this.selectedEngineer += element["itemName"] + ", ";
      this.selectedQuotationId += element["id"] + ", ";
    });
  }

  GetAllProject() {
    let data = {};
    this.nameId = [];
    this.UserService.GetAllProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.nameArray = res;
        this.nameId = [];
        for (const nameData of this.nameArray["Data"]) {
          this.nameId.push({
            id: nameData["ProjectId"],
            itemName: `${nameData["ProjectName"]} (${nameData["ProjectNumber"]})`,
          });
        }
      } else {
        this.nameArray = [];
      }
    });
  }
  selectedId: any = [];
  selectedName: string = "";
  selectedNameId: string = "";
  onIdSelect(item: any) {
    this.selectedName = "";
    this.selectedNameId = "";
    this.selectedId.forEach((element) => {
      this.selectedName += element["itemName"] + ", ";
      this.selectedNameId += element["id"] + ", ";
    });
  }

  Sales() {
    let data = {};
    this.sales = [];
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.salesArray = res;
        this.sales = [];
        for (const salesData of this.salesArray["Data"]) {
          this.sales.push({
            id: salesData["UserId"],
            itemName: `${salesData["UserName"]} - ${salesData["EmployeeId"]}`,
          });
        }
      } else {
        this.salesArray = [];
      }
    });
  }
  selectedSales: any = [];
  selectedsales: string = "";
  selectedSalesId: string = "";
  onSalesSelect(item: any) {
    this.selectedsales = "";
    this.selectedSalesId = "";
    this.selectedSales.forEach((element) => {
      this.selectedsales += element["itemName"] + ", ";
      this.selectedSalesId += element["id"] + ", ";
    });
  }

  Territory() {
    let data = {};
    this.territory = [];
    this.UserService.GetTerritory(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TerritoryArray = res;
        this.territory = [];
        for (const territoryData of this.TerritoryArray["Data"]) {
          this.territory.push({
            id: territoryData["Id"],
            itemName: territoryData["TerritoryName"],
          });
        }
      } else {
        this.TerritoryArray = [];
      }
    });
  }
  selectedTerritory: any = [];
  selectedterritory: string = "";
  selectedTerritoryId: string = "";
  onTerritorySelect(item: any) {
    this.selectedterritory = "";
    this.selectedTerritoryId = "";
    this.selectedTerritory.forEach((element) => {
      this.selectedterritory += element["itemName"] + ", ";
      this.selectedTerritoryId += element["id"] + ", ";
    });
  }

  Status() {
    let data = {};
    this.status = [];
    this.UserService.GetProjectStatus(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.StatusArray = res;
        this.status = [];
        for (const statusData of this.StatusArray["Data"]) {
          this.status.push({
            id: statusData["StatusID"],
            itemName: statusData["StatusName"],
          });
        }
      } else {
        this.StatusArray = [];
      }
    });
  }
  selectedStatus: any = [];
  selectedstatus: string = "";
  selectedStatusId: string = "";
  onStatusSelect(item: any) {
    this.selectedstatus = "";
    this.selectedStatusId = "";
    this.selectedStatus.forEach((element) => {
      this.selectedstatus += element["itemName"] + ", ";
      this.selectedStatusId += element["id"] + ", ";
    });
  }

  edit(id) {
    let encryptid = this.UserService.encryptData(id);
    this.router.navigate(["/project/editproject", encryptid]);
  }

  view(eid) {
    if (this.permission.Project_View == 1 || this.userRId == 1) {
      let encryptid = this.UserService.encryptData(eid);
      this.router.navigate(["/project/projectdetails", encryptid]);
    } else {
      this.toastr.error("Permission Denied !");
    }
  }

  clearEndDate() {
    this.date_range = null;
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (
      this.fromDate &&
      !this.toDate &&
      date &&
      date.after(this.fromDate)
    ) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  dateChangeFun() {
    if (this.date_range && this.date_range != undefined) {
      if (this.date_range.startDate != null) {
        this.start_date = this.datePipe.transform(
          this.date_range.startDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );
        this.end_date = this.datePipe.transform(
          this.date_range.endDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );
        this.start_date = moment(this.start_date, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
        this.end_date = moment(this.end_date, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
      } else {
        this.start_date = "";
      }
    }
  }

  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.showcompany.slice(start, end);
    this.dataSource = part;
  }

  tt: any;
  onSubmit() {
    let start, end;
    this.showTable = false;
    this.spinner.show();
    if (
      this.date_range.startDate &&
      this.date_range.startDate != "" &&
      this.date_range.endDate &&
      this.date_range.endDate != ""
    ) {
      start = this.datePipe.transform(this.date_range.startDate, "yyyy-MM-dd");
      end = this.datePipe.transform(this.date_range.endDate, "yyyy-MM-dd");
    } else {
      start = "";
      end = "";
    }
    let data = {
      ProjectId: this.selectedNameId,
      QuotationEngineer: this.selectedQuotationId,
      SalesEngineer: this.selectedSalesId,
      Territory: this.selectedTerritoryId,
      ProjectStatus: this.selectedStatusId,
      SearchWord: "",
      StartDate: start,
      EndDate: end,
      Sort: "",
      SortWise: "",
      Export: "",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.UserService.ProjectListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        this.showTable = true;
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.TotalRecord = res["TotalRecord"];
        this.tt = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.router.navigate(["/project/projectlist"]);
      } else if (res["result"] == "Failed") {
        this.toastr.error(res["Msg"]);
        this.spinner.hide();
      } else {
        this.toastr.error(res["Msg"]);
        this.spinner.hide();
      }
    });
  }

  resetData() {
    this.selectedNameId = "";
    this.selectedQuotationId = "";
    this.selectedSalesId = "";
    this.selectedTerritoryId = "";
    this.selectedStatusId = "";
    this.selecteddate_range = [];
    this.registerForm.reset();
    this.totalSize = this.tt;
    this.ngOnInit();
    this.isCollapsed = true;
  }

  onItemSelect(item: any) { }
  OnItemDeSelect(item: any) { }
  onSelectAll(items: any) { }
  onDeSelectAll(items: any) { }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  onDateSelection2(date: NgbDate) {
    if (!this.fromDate2 && !this.toDate) {
      this.fromDate2 = date;
    } else if (
      this.fromDate2 &&
      !this.toDate &&
      date &&
      date.after(this.fromDate2)
    ) {
      this.toDate2 = date;
    } else {
      this.toDate2 = null;
      this.fromDate2 = date;
    }
  }

  isHovered2(date: NgbDate) {
    return (
      this.fromDate2 &&
      !this.toDate2 &&
      this.hoveredDate2 &&
      date.after(this.fromDate2) &&
      date.before(this.hoveredDate2)
    );
  }

  isInside2(date: NgbDate) {
    return (
      this.toDate2 && date.after(this.fromDate2) && date.before(this.toDate2)
    );
  }

  isRange2(date: NgbDate) {
    return (
      date.equals(this.fromDate2) ||
      (this.toDate2 && date.equals(this.toDate2)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput2(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter2.parse(input);
    return parsed && this.calendar2.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }

  openClosefun1() {
    this.isCollapsed1 = !this.isCollapsed1;
  }

  ExportOpenModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-dialog-centered",
    });
  }

  exportConfirm() {
    this.exportProject();
    this.modalRef.hide();
  }

  exportProject() {
    let start, end;
    this.spinner.show();
    if (
      this.date_range.startDate &&
      this.date_range.startDate != "" &&
      this.date_range.endDate &&
      this.date_range.endDate != ""
    ) {
      start = this.datePipe.transform(this.date_range.startDate, "yyyy-MM-dd");
      end = this.datePipe.transform(this.date_range.endDate, "yyyy-MM-dd");
    } else {
      start = "";
      end = "";
    }
    let data = {
      ProjectId: this.selectedNameId,
      QuotationEngineer: this.selectedQuotationId,
      SalesEngineer: this.selectedSalesId,
      Territory: this.selectedTerritoryId,
      ProjectStatus: this.selectedStatusId,
      SearchWord: this.searchword,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "true",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      StartDate: start,
      EndDate: end,
    };
    this.UserService.ProjectListFilter(data).subscribe((res: any) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        let exporturl = res["Data"];
        window.open(this.baseurl + "/" + exporturl);
      }
    });
  }

  public handlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.iterator();
    let data = {
      ProjectId: this.selectedNameId,
      SalesEngineer: this.selectedSalesId,
      QuotationEngineer: this.selectedQuotationId,
      Territory: this.selectedTerritoryId,
      ProjectStatus: this.selectedStatusId,
      ProjectSource: "",
      SearchWord: this.searchword,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "",
      StartDate: "",
      EndDate: "",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.UserService.ProjectListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
      }
    });
  }

  onSortData(sort: Sort) {
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortData = [];
    this.sortData = { column: sort.active, direction: sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    } else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;
    let data = {
      SearchWord: this.searchword,
      ProjectId: this.selectedNameId,
      SalesEngineer: this.selectedSalesId,
      QuotationEngineer: this.selectedQuotationId,
      Territory: this.selectedTerritoryId,
      ProjectStatus: this.selectedStatusId,
      ProjectSource: "",
      StartDate: "",
      EndDate: "",
      Sort: sort.active,
      SortWise: sort.direction,
      Export: "false",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.dataSource = [];
    this.spinner.show();
    this.UserService.ProjectListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
      }
    });
  }

  deleteOpenModal(template: TemplateRef<any>, data) {
    if (data) {
      this.deleteId = data.ProjectId;
      this.removeId = data.ProjectNumber;
      this.file = data.ProjectName;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  decline() {
    this.modalRef.hide();
  }

  deleteConfirm() {
    this.deleteProject();
    this.modalRef.hide();
  }

  deleteProject() {
    this.spinner.show();
    this.pvalue = this.registerForm.value.password;
    this.UserService.UpdateProjectStatus({
      ProjectId: this.deleteId,
      Status: 3,
      Password: this.pvalue,
    }).subscribe((response: any) => {
      if (response["result"] == "success") {
        this.spinner.hide();
        this.toastr.success("Project Deleted Successfully!");
        this.ngOnInit();
      } else {
        this.spinner.hide();
        this.err_message = response.Msg;
        this.toastr.error(this.err_message);
      }
    });
  }

  //restore
  restoreOpenModal(template: TemplateRef<any>, data) {
    if (data) {
      this.restoreId = data.ProjectId;
      this.file = data.ProjectName;
      this.RestoreId = data.ProjectNumber;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  restoreConfirm() {
    this.restoreProject();
    this.modalRef.hide();
  }

  restoreProject() {
    this.spinner.show();
    this.UserService.Restore({ ProjectId: this.restoreId }).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.spinner.hide();
          this.toastr.success("Project Restore Successfully!");
          this.router
            .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
            .then(() => {
              this.router.navigateByUrl("/project/projectlist");
            });
        } else {
          this.err_message = response.Msg;
        }
      }
    );
  }

  applyFilter() {
    this.spinner.show();
    let data = {
      SearchWord: this.searchword,
      ProjectId: this.selectedNameId,
      SalesEngineer: this.selectedSalesId,
      QuotationEngineer: this.selectedQuotationId,
      Territory: "",
      ProjectStatus: "",
      Sort: "",
      SortWise: "",
      Export: "false",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      StartDate: "",
      EndDate: "",
    };
    this.UserService.ProjectListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
      }
    });
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = "";
    if (
      previousValue &&
      previousValue.length > 0 &&
      previousValue !== this.searchword
    ) {
      this.clearEvent.emit();
    }
  }

  onChange(evt) {
    let data, header;
    const target: DataTransfer = <DataTransfer>evt.target;
    this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
    if (this.isExcelFile != true) {
      this.toastr.error("Invaild File Format. Only xlsx Files Are Allowed !");
      return;
    }
    this.upfile = target.files[0];
    if (target.files.length > 1) {
      this.inputFile.nativeElement.value = "";
    }
    if (this.isExcelFile) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        // read workbook /
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

        // grab first sheet /
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        /* for header */
        let arrHeaderMain = wb["Sheets"][wsname];
        if (arrHeaderMain == undefined || arrHeaderMain == null) {
          this.count = 0;
        } else {
          this.arrHeader.push(arrHeaderMain.A1?.h);
          this.arrHeader.push(arrHeaderMain.B1?.h);
          this.arrHeader.push(arrHeaderMain.C1?.h);
          this.arrHeader.push(arrHeaderMain.D1?.h);
          this.arrHeader.push(arrHeaderMain.E1?.h);
          this.arrHeader.push(arrHeaderMain.F1?.h);
        }

        // save data /
        this.data = XLSX.utils.sheet_to_json(ws);
      };

      reader.readAsBinaryString(target.files[0]);

      reader.onloadend = (e) => {
        this.showproject = Object.keys(this.data);

        this.count = 0;
        let arr = [
          "ProjectName",
          "QuotationEngineer",
          "SalesEngineer",
          "ProjectSource",
          "Territory",
          "ProjectStatus",
        ];
        if (
          JSON.stringify(this.arrHeader) === JSON.stringify(arr) &&
          this.arrHeader.length > 0
        ) {
          if (this.showproject.length > 0) {
            if (this.showproject.length <= 1000) {
              this.count = 2;
            } else {
              this.count = 3;
            }
          } else {
            this.count = 1;
          }
        } else {
          this.count = 0;
        }
      };
    } else {
      this.inputFile.nativeElement.value = "";
    }
  }

  import() {
    if (this.data == undefined) {
      this.toastr.error("Please Select a valid xlsx file");
      return;
    } else if (this.count == 0) {
      this.toastr.error("Invalid Template!");
      return;
    } else if (this.count == 1) {
      this.toastr.error("File should not be empty !");
      return;
    } else if (this.count == 3) {
      this.toastr.error("Maximum 1000 records are allowed !");
      return;
    } else {
      this.spinner.show();
      this.UserService.ImportProjectList(this.data).subscribe((res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.showimport.nativeElement.click();
          this.Totalrec = res["TotalRecord"];
          this.invalid = res["InvaildRow"];
          this.valid = this.Totalrec - this.invalid;
          this.dataarray = res["Data"];
          this.toastr.success("Project save successfully");
        } else if (res["result"] == "Failed") {
          this.spinner.hide();
          this.showimport.nativeElement.click();
          this.isValid = true;
          this.Totalrec = res["TotalRecord"];
          this.invalid = res["InvaildRow"];
          this.valid = this.Totalrec - this.invalid;
          this.dataarray = res["Data"];
        } else {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        }
      });
    }
  }

  //space not allowed
  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }

  rtnView() {
    this.router
      .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
      .then(() => {
        this.router.navigateByUrl("/project/projectlist");
      });
  }


  // startEditing(rowIndex: number, columnKey: string) {
  //   this.editingRowIndex = rowIndex;
  //   this.editingColumnKey = columnKey;
  //   this.editableValue = this.dataSource.data[rowIndex][columnKey];
  // }

  // // Method to check if a cell is being edited
  // isEditing(rowIndex: number, columnKey: string): boolean {
  //   return this.editingRowIndex === rowIndex && this.editingColumnKey === columnKey;
  // }

  // // Method to finish editing a cell
  // finishEditing(rowIndex: number, columnKey: string) {
  //   if (this.isEditing(rowIndex, columnKey)) {
  //     this.dataSource.data[rowIndex][columnKey] = this.editableValue;
  //     // Call your update API here to save changes to the backend
  //     // Reset editing state
  //     this.editingRowIndex = -1;
  //     this.editingColumnKey = '';
  //   }
  // }

}
